import { render, staticRenderFns } from "./RecentQuotes.vue?vue&type=template&id=0f3b5822&"
import script from "./RecentQuotes.vue?vue&type=script&lang=js&"
export * from "./RecentQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f3b5822')) {
      api.createRecord('0f3b5822', component.options)
    } else {
      api.reload('0f3b5822', component.options)
    }
    module.hot.accept("./RecentQuotes.vue?vue&type=template&id=0f3b5822&", function () {
      api.rerender('0f3b5822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/recent-quotes/RecentQuotes.vue"
export default component.exports